import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

const ConsentTermsAndConditions = () => {
    return (
        <div className="sid-consent-terms-and-conditions-container">
            <div className="sid-consent-outsourced">
                <FormattedHTMLMessage
                    id="informationOutsourcedToSheerId"
                    defaultMessage="The process of verifying student or faculty status is outsourced to SheerID, a partner of ASICS Japan K.K."
                />
            </div>
            <div className="sid-consent-transmitted-to-us">
                <FormattedHTMLMessage
                    id="informationTransferredAndUsedForVerification"
                    defaultMessage="The personal information provided by this form will be transferred to the United States and used for the purpose of student or faculty status verification and coupon code notification in accordance with <a href='https://www.sheerid.com/privacy_notice_services_japanese/'>SheerID’s Privacy Policy</a>."
                />
            </div>
            <div className="sid-consent-more-information">
                <FormattedHTMLMessage
                    id="forMoreInformationAsics"
                    defaultMessage="For more information on the handling of personal information provided by SheerID to ASICS Japan K.K. through the authentication process, please refer to the <a href='https://www.asics.com/jp/ja-jp/mk/support/guide/'>ASICS Privacy Policy</a>."
                />
            </div>
        </div>
    );
};

export { ConsentTermsAndConditions };
